import * as React from 'react';
import { LazyLoadComponentWrapper } from '@components/lazy-load/lazy-load-component-wrapper';
import { PageLazyLoadingIndicator } from '@components/page-lazy-loading-indicator';
import { isAccessibilityEnabled } from '@applications/utility-methods';

const { lazy } = React;
// import OrderSuccess from './index'
const NewOrderSubmission = lazy(() => import(/* webpackChunkName:"int-store" */'./index'));
const NewOrderSubmissionAble = lazy(() => import(/* webpackChunkName:"int-store" */'./index-able'));


export const OrderSubmission = () => {
    return (
        <LazyLoadComponentWrapper
        fallback={<PageLazyLoadingIndicator error={false}/>}
        errorIndicator={<PageLazyLoadingIndicator error={true}/>} >
            {isAccessibilityEnabled() ? <NewOrderSubmissionAble /> : <NewOrderSubmission />}
        </LazyLoadComponentWrapper>
    )
};
